const CMS_CONFIG = {
  CONTENTFUL: {
    spaceName: `Space`,
    spaceId: `Space Id`,
    url: `spaceName`,
  },
  DATOCMS: {
    projectName: `Project`,
    projectId: `Project Id`,
    url: `projectName`,
  },
  COSMICJS: {
    bucketSlugName: `Bucket`,
    bucketSlugId: `Bucket Id`,
    url: `bucketSlugName`,
  },
  SANITY: {
    projectId: `Project ID`,
    projectName: `Project Name`,
    dataset: `Dataset`,
    url: `projectName`,
  },
}

export const formatCmsConfiguration = ({ config, features, vendor }) => {
  const cmsConfig = []

  if (config) {
    Object.entries(config).forEach(([key, value]) => {
      if (CMS_CONFIG[vendor][key]) {
        const configUrl = CMS_CONFIG[vendor][`url`] === key && {
          url: config.managementUrl || ``,
        }

        const cmsObj = {
          name: CMS_CONFIG[vendor][key],
          value,
          ...configUrl,
        }

        if (configUrl) cmsConfig.unshift(cmsObj)
        else cmsConfig.push(cmsObj)
      }
    })
  }

  if (features) {
    cmsConfig.push(
      {
        name: `Build Webhook`,
        value: !!features?.webhooks,
      },
      {
        name: `Environment Variables`,
        value: !!features?.envVars,
      },
      {
        name: `Preview Extension`,
        value: !!features?.extension,
      }
    )
  }

  return cmsConfig
}
